import React, { useState } from "react";
import "./headerUserDisconnected.scss";
import PropTypes from "prop-types";
import { FaRegUserCircle, FaAngleDown } from "react-icons/fa";
import ModalCharte from "Components/Modal/ModalCharte/ModalCharte";
import { updateAuth } from "../../../../Redux/Actions/authActions";
import { connect } from "react-redux";
import ModalCreationCompte from "../../../Modal/ModalCreationCompte/ModalCreationCompte";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";

const headerUserDisconnected = () => {
  // const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  const [openConnexionInterface, setOpenConnexionInterface] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalCreationCompte, setVisibleModalCreationCompte] =
    useState(false);
  const [visibleModalCharte, setvisibleModalCharte] = useState(false);

  return (
    <div className="header__bandeau__userDisconnected">
      <button
        onMouseEnter={() => setOpenConnexionInterface(true)}
        onMouseLeave={() => setOpenConnexionInterface(false)}
      >
        <FaRegUserCircle className="header__bandeau__user__icon" />
        CONNEXION
        <FaAngleDown />
      </button>
      {openConnexionInterface && (
        <div
          className="connexionInterface"
          onMouseEnter={() => setOpenConnexionInterface(true)}
          onMouseLeave={() => setOpenConnexionInterface(false)}
        >
          <ul>
            <li onClick={() => setVisibleModal(!visibleModal)}>Se connecter</li>
            <li
              onClick={() =>
                setVisibleModalCreationCompte(!visibleModalCreationCompte)
              }
            >
              Créer un compte
            </li>
          </ul>
        </div>
      )}
      {visibleModal && (
        <ModalConnexion
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
        ></ModalConnexion>
      )}

      {visibleModalCharte && (
        <ModalCharte
          visibleModal={visibleModalCharte}
          setVisibleModal={setvisibleModalCharte}
        >
          <div className="description">
            <ModalCharte />
          </div>
        </ModalCharte>
      )}

      {visibleModalCreationCompte && (
        <ModalCreationCompte
          visibleModal={visibleModalCreationCompte}
          setVisibleModal={setVisibleModalCreationCompte}
        ></ModalCreationCompte>
      )}
    </div>
  );
};

headerUserDisconnected.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  universities: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  universities: state.universities,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(headerUserDisconnected);
